import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';

/**
 * Loading view for the Build component
 * @returns {React.ReactElement} Loading view component
 */
const LoadingView = () => {
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        flexDirection: 'column',
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '300px',
        width: '100%',
        textAlign: 'center',
        px: 3
      }}
    >
      <CircularProgress 
        size={50} 
        sx={{ mb: 3 }} 
      />
      
      <Typography 
        variant="h6" 
        color="text.primary"
        sx={{ mb: 1 }}
      >
        Loading Development Plan
      </Typography>
      
      <Typography 
        variant="body1" 
        color="text.secondary"
        sx={{ maxWidth: '600px' }}
      >
        We're preparing your build phases and development tasks. This might take a moment...
      </Typography>
    </Box>
  );
};

export default LoadingView;